import {
  Delete as DeleteIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Task as DocumentSystemFileIcon,
  Download as DownloadIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import { Avatar, Box, IconButton, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getBeautifiedLocalDateTime } from '@/core';

type FileItemProps = {
  name: string;
  uploadedBy?: string;
  uploadedAt?: string;
  storeType?: string;
  onDownload?: () => void;
  onDelete?: () => void;
  onNewVersion?: () => void;
  version?: string;
  info?: string;
  fileName?: string;
};

const FileItem = ({
  name,
  uploadedBy,
  uploadedAt,
  storeType,
  onDownload,
  onDelete,
  onNewVersion,
  version,
  info,
  fileName,
}: FileItemProps) => {
  const { t } = useTranslation();

  return (
    <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <ListItemAvatar>
          <Avatar>
            {name.startsWith('Honorar') ? <DocumentSystemFileIcon /> : <InsertDriveFileIcon />}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primaryTypographyProps={{ fontSize: '1.25rem' }}
          secondaryTypographyProps={{ fontSize: '1rem' }}
          primary={name}
          secondary={
            <>
              {uploadedBy && (
                <div>
                  {t('Uploaded by', { defaultValue: 'Uploaded by' })}: {uploadedBy}
                </div>
              )}
              {uploadedAt && (
                <div>
                  {t('Upload date', { defaultValue: 'Upload date' })}:{' '}
                  {getBeautifiedLocalDateTime(uploadedAt)}
                </div>
              )}
              {version && (
                <div>
                  {t('Version', { defaultValue: 'Version' })}: {version}
                </div>
              )}
              {fileName && (
                <div>
                  {t('File name', { defaultValue: 'File name' })}: {fileName}
                </div>
              )}
              {info && (
                <div>
                  {t('Note', { defaultValue: 'Note' })}: {info}
                </div>
              )}
            </>
          }
        />
      </Box>
      <Box>
        {!!onNewVersion && (
          <IconButton
            size="large"
            onClick={() => {
              onNewVersion();
            }}
          >
            <AddIcon />
          </IconButton>
        )}
        {!!onDownload && (
          <IconButton
            size="large"
            onClick={() => {
              onDownload();
            }}
          >
            <DownloadIcon />
          </IconButton>
        )}
        {!!onDelete && (
          <IconButton
            size="large"
            onClick={() => {
              onDelete();
            }}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
    </ListItem>
  );
};

export default FileItem;
